import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestUpdateParcelSizes } from "./updateParcelSizes.request";

const useUpdateParcelSizes = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestUpdateParcelSizes,
    onError: toastServerError,
    ...options
  });
};

export default useUpdateParcelSizes;
